/**
 * Theme-aware color hook
 * Auto-resolves light/dark color variants based on current color mode
 * All values sourced from gluestack-ui.config.ts via colors.ts
 */

import { useMemo } from 'react';
import { useColorMode } from '../contexts/ColorModeContext';
import { colors } from './colors';

export function useThemeColors() {
  const { isDark } = useColorMode();

  return useMemo(() => ({
    // Backgrounds
    background: isDark ? colors.backgroundDark : colors.background,
    card: isDark ? colors.cardDark : colors.card,
    inputBg: isDark ? colors.inputBgDark : colors.inputBg,
    primarySoft: isDark ? colors.primarySoftDark : colors.primarySoft,
    accentSoft: isDark ? colors.accentSoftDark : colors.accentSoft,
    secondarySoft: isDark ? colors.secondarySoftDark : colors.secondarySoft,
    warningBg: isDark ? colors.warningBgDark : colors.warningBg,
    errorBg: isDark ? colors.errorBgDark : colors.errorBg,
    successBg: isDark ? colors.successBgDark : colors.successBg,
    infoBg: isDark ? colors.infoBgDark : colors.infoBg,

    // Text
    text: isDark ? colors.textDark : colors.text,
    textSecondary: isDark ? colors.textSecondaryDark : colors.textSecondary,
    inputPlaceholder: isDark ? colors.inputPlaceholderDark : colors.inputPlaceholder,

    // Borders
    border: isDark ? colors.borderDark : colors.border,

    // Overlay
    overlay: isDark ? colors.overlayDark : colors.overlay,

    // Static (same in both modes)
    primary: colors.primary,
    primary50: colors.primary50,
    primary400: colors.primary400,
    primary600: colors.primary600,
    primary700: colors.primary700,
    secondary: colors.secondary,
    error: colors.error,
    success: colors.success,
    warning: colors.warning,
    accent: colors.accent,
    recording: colors.recording,

    // Gradients
    userBubbleGradient: [colors.userBubbleStart, colors.userBubbleEnd] as [string, string],
    avatarGradient: [colors.primary, colors.secondary] as [string, string],

    // Raw isDark for edge cases
    isDark,
  }), [isDark]);
}
